<script>
  import { xhr, toast } from "$app/utils"
  import Button from "$app/components/ButtonSpinner.svelte"
  import Honeybadger from "$app/utils/honeybadger"
  import { appStore } from "$app/store.svelte"

  const initialVals = {
    current_password: "",
    password: "",
    password_confirmation: ""
  }
  let form = $state({ ...initialVals })
  let errors = $state({})

  let saving = $state(false)
  async function updatePassword() {
    saving = true
    errors = {}
    if (form.password.trim() === "") {
      errors.password = ["You must set a new password"]
      return
    }

    try {
      const resp = await xhr.put(
        `/users/${appStore.current_user.id}/update_password`,
        {
          user: form
        }
      )

      toast("The password has been updated.", "success")
      form = { ...initialVals }
    } catch (e) {
      if (typeof Honeybadger.notify !== "undefined") {
        Honeybadger.notify(e)
      }
      toast("There was an error updating your password", "error")
      if (e.response) {
        errors = { ...errors, ...e.response.data.errors }
      }
    } finally {
      saving = false
    }
  }
</script>

<div class="space-y-8">
  <div>
    <p class="mt-1 max-w-2xl text-lg text-gray-700">
      Please use this form to change your password.
    </p>
    <div class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
      <div class="sm:col-span-6">
        <label for="email" class="block text-sm font-medium text-gray-700">
          Current Password
        </label>
        <div class="mt-1 input-cont" class:error={errors.current_password}>
          <input
            type="password"
            bind:value={form.current_password}
            class="input w-full"
          />
          <div class="msg">{errors.current_password}</div>
        </div>
      </div>

      <div class="sm:col-span-6">
        <label for="email" class="block text-sm font-medium text-gray-700">
          New Password
        </label>
        <div class="mt-1 input-cont" class:error={errors.password}>
          <input
            type="password"
            bind:value={form.password}
            class="input w-full"
          />
          <div class="msg">{errors.password}</div>
        </div>
      </div>
      <div class="sm:col-span-6">
        <label for="email" class="block text-sm font-medium text-gray-700">
          Confirm New Password
        </label>
        <div class="mt-1 input-cont" class:error={errors.password_confirmation}>
          <input
            type="password"
            bind:value={form.password_confirmation}
            class="input w-full"
          />
          <div class="msg">{errors.password_confirmation}</div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-span-6 py-4 text-center">
    <Button
      onclick={updatePassword}
      processing={saving}
      class="btn-rounded bg-green-600 hover:bg-green-700 text-white btn-big w-full text-lg font-bold md:w-72 h-14"
    >
      Update Password
    </Button>
  </div>
</div>
